(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ketch-brand-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var brandNtGrids = new Map();

  function buildBrandNTCardHTML(product) {
    var price = parseFloat((product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.amount) || 0);
    var compareAt = parseFloat((product.compareAtPriceRange && product.compareAtPriceRange.maxVariantPrice && product.compareAtPriceRange.maxVariantPrice.amount) || 0);
    var hasDiscount = compareAt > 0 && compareAt > price;
    var discount = hasDiscount ? Math.round((1 - price / compareAt) * 100) : 0;
    var img = product.featuredImage ? product.featuredImage.url : '';
    var imgAlt = product.featuredImage ? (product.featuredImage.altText || product.title) : product.title;
    var formatPrice = function (n) { return '\u20B9' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); };

    var productGid = product.id;
    var variantGid = (product.variants && product.variants.edges && product.variants.edges[0]) ? product.variants.edges[0].node.id : '';
    var wishlistHTML = '<div class="spectrum-wl-btn--card" data-spectrum-wishlist-btn data-product-gid="' + productGid + '" data-variant-gid="' + variantGid + '" data-product-handle="' + product.handle + '">' +
      '<button type="button" class="spectrum-wl-btn" aria-label="Add to wishlist" title="Add to wishlist">' +
      '<svg class="spectrum-wl-heart" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>' +
      '</button></div>';

    return '<div class="ketch-brand-nt__grid-item">' +
      '<product-card class="ketch-card" data-product-id="' + product.id + '">' +
      '<div class="ketch-card__image" style="--ketch-card-ratio: 3 / 4;">' +
      '<a href="/products/' + product.handle + '" class="ketch-card__image-link">' +
      (img ? '<img class="ketch-card__img" src="' + img + '" alt="' + imgAlt + '" loading="lazy">' : '<div class="ketch-card__placeholder"></div>') +
      '</a>' +
      wishlistHTML +
      '</div>' +
      '<div class="ketch-card__content">' +
      '<div class="ketch-card__row-brand">' +
      (product.vendor ? '<span class="ketch-card__brand">' + product.vendor + '</span>' : '') +
      '</div>' +
      '<p class="ketch-card__title">' + product.title + '</p>' +
      '<div class="ketch-card__pricing">' +
      '<span class="ketch-card__price ketch-card__price--sale">' + formatPrice(price) + '</span>' +
      (hasDiscount ? '<span class="ketch-card__price ketch-card__price--compare">' + formatPrice(compareAt) + '</span>' +
        '<span class="ketch-card__discount">-' + discount + '%</span>' : '') +
      '</div>' +
      '</div>' +
      '</product-card>' +
      '</div>';
  }

  function fetchBrandNTByType(productType, vendors, callback) {
    var cfg = window.KetchConfig;
    if (!cfg || !cfg.storefrontToken) { callback(new Error('KetchConfig missing'), []); return; }

    var gqlQuery = [
      'query BrandNTFilter($q: String!) {',
      '  products(first: 8, query: $q) {',
      '    edges { node {',
      '      id title handle productType vendor',
      '      priceRange { minVariantPrice { amount currencyCode } }',
      '      compareAtPriceRange { maxVariantPrice { amount currencyCode } }',
      '      featuredImage { url altText }',
      '      variants(first: 1) { edges { node { id } } }',
      '    } }',
      '  }',
      '}'
    ].join('\n');

    var vendorClause = '';
    if (vendors && vendors.length === 1) {
      vendorClause = 'vendor:"' + vendors[0] + '" ';
    } else if (vendors && vendors.length > 1) {
      vendorClause = '(' + vendors.map(function (v) { return 'vendor:"' + v + '"'; }).join(' OR ') + ') ';
    }
    var queryStr = vendorClause + 'product_type:"' + productType + '"';

    fetch(cfg.storefrontUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': cfg.storefrontToken
      },
      body: JSON.stringify({ query: gqlQuery, variables: { q: queryStr } })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var edges = data.data && data.data.products ? data.data.products.edges : [];
        callback(null, edges.map(function (e) { return e.node; }));
      })
      .catch(function (err) { callback(err, []); });
  }

  function initBrandNTFilterPills() {
    var containers = document.querySelectorAll('.ketch-brand-nt[data-brand-nt-collection]');
    containers.forEach(function (nt) {
      if (nt.dataset.brandNtPillsInit) return;
      nt.dataset.brandNtPillsInit = 'true';

      var pills = nt.querySelectorAll('.ketch-brand-nt__pill');
      var grid = nt.querySelector('.ketch-brand-nt__grid--filterable');
      if (!pills.length || !grid) return;

      brandNtGrids.set(nt, grid.innerHTML);
      var vendorsRaw = (nt.dataset.brandNtVendors || '').trim();
      var vendors = vendorsRaw ? vendorsRaw.split(',').map(function (v) { return v.trim(); }).filter(Boolean) : [];

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.classList.contains('ketch-filter-pill--active')) return;
          pills.forEach(function (p) { p.classList.remove('ketch-filter-pill--active'); });
          pill.classList.add('ketch-filter-pill--active');

          var filter = pill.dataset.filter;
          if (filter === 'all') {
            grid.style.minHeight = grid.offsetHeight + 'px';
            grid.innerHTML = brandNtGrids.get(nt);
            grid.style.minHeight = '';
            return;
          }

          grid.classList.add('ketch-brand-nt__grid--loading');
          var shimmerHTML = '';
          for (var s = 0; s < 8; s++) shimmerHTML += '<div class="ketch-brand-nt__grid-shimmer"></div>';
          grid.innerHTML = shimmerHTML;
          fetchBrandNTByType(filter, vendors, function (err, products) {
            grid.classList.remove('ketch-brand-nt__grid--loading');
            if (err || !products.length) {
              grid.innerHTML = '<div style="padding:24px 12px;text-align:center;color:#a3a3a3;font-size:13px;grid-column:1/-1;">No products found.</div>';
              return;
            }
            grid.innerHTML = products.map(buildBrandNTCardHTML).join('');
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrandNTFilterPills);
  } else {
    initBrandNTFilterPills();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.classList.contains('ketch-brand-page-section')) {
      initBrandNTFilterPills();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
